// --- generateShortUUID
// genreate a short uuid
// better for general purposes on a given page when the data is localized

import generate from "./generate.js"

export default function generateShortUUID ({ seed } = {}) {
    return generate({ seed })
}